import { CommonUtilityModule } from './common-utility.module';
import { SharedTranslateLazyModule } from './shared-translate-lazy.module';

import { HeaderComponent } from './header/header.component';
import { LeftMenuComponent } from './left-menu/left-menu.component';
import { RouterModule } from '@angular/router';


import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HelpTextComponent} from './help-text/help-text.component';


@NgModule({
  imports: [RouterModule,CommonModule,SharedTranslateLazyModule,CommonUtilityModule],
  declarations: [LeftMenuComponent,HeaderComponent,HelpTextComponent ],
 
  exports: [LeftMenuComponent,HeaderComponent, RouterModule,HelpTextComponent]

})

export class LeftMenuModule { }
